import { getCountryByCurrency } from '@utils/locations';
import { useEffect, useState } from 'react';

import { VARIANT_AVAILABILITY } from '../apollo/shopify/queries';
import { storefrontClient } from '../apollo/shopify/storefrontClient';
import { ShopifyProductVariantAvailability } from '../features/private-sales/types/PrivateLink';
import { useCurrency } from './useCurrency';

type Result = {
  availabilities: ShopifyProductVariantAvailability[];
  loading: boolean;
};

export const useProductVariantAvailabilities = (
  variantIds: string[],
): Result => {
  const [availabilities, setAvailabilities] = useState<
    ShopifyProductVariantAvailability[]
  >([]);
  const [loading, setLoading] = useState(true);
  const [currency] = useCurrency();

  const fetchItems = async () => {
    setLoading(true);

    const { data } = await storefrontClient.query<{
      nodes: ShopifyProductVariantAvailability[]; // not an accurate type but satisfies the linter so we can activate it for the entire dir
    }>({
      query: VARIANT_AVAILABILITY,
      variables: {
        country: getCountryByCurrency(currency),
        ids: variantIds,
      },
      fetchPolicy: 'no-cache',
    });

    const results = data.nodes.filter((node) => node !== null);

    const nextItems = variantIds
      .map((id) => results.find((node) => node.id === id))
      .filter((result) => result !== undefined);

    setAvailabilities(nextItems);
    setLoading(false);
  };

  useEffect(() => {
    fetchItems();
  }, [currency, variantIds.join('_')]);

  return {
    availabilities,
    loading,
  };
};
